export enum enumManufacturingProductGroupType {
    VerandaProfile = 1,
    VerandaGlass = 2,
    VerandaPolycarbonate = 3,
    All = 4
};
